'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ClockIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="ClockIcon">
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.291016 7.00081C0.291016 7.88177 0.464532 8.75409 0.801657 9.56798C1.13878 10.3819 1.63291 11.1214 2.25584 11.7443C2.87877 12.3672 3.61829 12.8614 4.43218 13.1985C5.24607 13.5356 6.1184 13.7091 6.99935 13.7091C7.8803 13.7091 8.75263 13.5356 9.56652 13.1985C10.3804 12.8614 11.1199 12.3672 11.7429 11.7443C12.3658 11.1214 12.8599 10.3819 13.197 9.56798C13.5342 8.75409 13.7077 7.88177 13.7077 7.00081C13.7077 6.11986 13.5342 5.24754 13.197 4.43365C12.8599 3.61975 12.3658 2.88023 11.7429 2.25731C11.1199 1.63438 10.3804 1.14025 9.56652 0.803122C8.75263 0.465997 7.8803 0.29248 6.99935 0.29248C6.1184 0.29248 5.24607 0.465997 4.43218 0.803122C3.61829 1.14025 2.87877 1.63438 2.25584 2.25731C1.63291 2.88023 1.13878 3.61975 0.801657 4.43365C0.464532 5.24754 0.291016 6.11986 0.291016 7.00081Z"
          stroke={sx?.color || '#3D517B'}
          strokeWidth="0.583333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 3.79248V7.00081L10.5 10.2091"
          stroke={sx?.color || '#3D517B'}
          strokeWidth="0.583333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  )
}

ClockIcon.propTypes = {
  sx: PropTypes.object
}
